import './CarModelHero.scss';

import React from 'react';

import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react';

export default function CarModelHero({ fields }) {
  return (
    <div className={'container car-model-hero'}>
      <div className={'hero'}>
        <Image alt="hero" field={fields.image} className={'hero__img'} fill />
        <Image alt="hero" field={fields.mobileImage} className={'hero__imgMobile'} fill />
        <div className={'hero__content'}>
          <div className={'hero__content_text'} data-aos="fade-up" data-aos-offset="200">
            <span className={'hero__content_headline'}>{fields?.subTitle.value}</span>
            <p className={'hero__content_description'}>
              <RichText field={fields.title} />
            </p>
          </div>
          <div className={'hero__buttons'} data-aos="fade-up" data-aos-offset="200">
            <a
              href={`${fields?.buttonUrl?.value?.href || ''}${
                fields?.buttonUrl?.value?.querystring || ''
              }`}
            >
              <button className={'hero__button'}>
                <span>{fields?.buttonText?.value}</span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
